module.exports = __webpack_public_path__ + "static/media/44497884_2199896870085492_8563858926422982656_o.d2c21587.jpg";